// Tabs/TabPanelContent.quality_safety.tsx
import React from 'react';
import ProductsDegradationTable from '../components/tabs/quality_safety/ProductsDegradationTable';
import ProductDegradationCompoundsTable from '../components/tabs/quality_safety/ProductDegradationCompoundsTable';
import StabilityTableCard from '../components/tabs/quality_safety/StabilityTable';
import ProductDegradationCard from '../components/tabs/quality_safety/ProductDegradation';
import ProductDegradationCompoundCard from '../components/tabs/quality_safety/ProductDegradationCompound';
import StabilityCard from '../components/tabs/quality_safety/Stability';
import DynamicTabContentTable from './DynamicTabContentTable';

interface TabPanelContentProps {
    dynamicCollections: any[];
}

const TabPanelContentQualitySafety: React.FC<TabPanelContentProps> = ({ dynamicCollections }) => (
    <div className="row">
        <div className="col-9 col-sm-9">
            <ProductsDegradationTable header={'Products Degradation'} eventGroupToTrigger={'quality_safety'} />
            <ProductDegradationCompoundsTable header={'Degradation Compounds of Product'} eventGroupToTrigger={'quality_safety'} />
            <StabilityTableCard header={'Stability compounds'} eventGroupToTrigger={'quality_safety'} />
            <DynamicTabContentTable dynamicCollections={dynamicCollections} tabName="quality_safety" />
        </div>
        <div className="col-3 col-sm-3">
            <ProductDegradationCard header={'Product Degradation Parameters'} eventGroupToTrigger={'quality_safety'} />
            <ProductDegradationCompoundCard header={'Compound Degradation'} eventGroupToTrigger={'quality_safety'} />
            <StabilityCard header={'Stability compounds'} eventGroupToTrigger={'quality_safety'} />
        </div>
    </div>
);

export default TabPanelContentQualitySafety;
